import styled from "styled-components";

const Calenderwrapper = styled.div`
  .form_wrapper {
    width:100%;
    .p-calendar {
      min-width: 100% !important;
      border-radius: 8px !important;
      z-index: 0 !important;
      align-items: center;
    }
    .p-button-icon-only {
      background: white;
      outline: none;
      box-shadow: none;
      border: none;
    }
  }
  .p-datepicker table th {
    text-align: center !important;
  }
  .Danger {
    color: #c4314b;
    font-weight: 400;
    font-size: 14px;
  }
  .inceptionDate {
    font-size: 0.9rem;
    line-height: 120%;
    letter-spacing: -0.01em;
    color: #444;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  .cal-inp {
    gap: 24px;
    background: #f2f3f5;
    border-bottom: 2px solid #f2f3f5;
    border-radius: 8px;
  }
  .p-float-label input:-webkit-autofill ~ label {
    top: -0.75rem;
  }
  .p-float-label input:focus ~ label,
  .p-float-label input.p-filled ~ label,
  .p-float-label textarea:focus ~ label,
  .p-float-label textarea.p-filled ~ label,
  .p-float-label .p-inputwrapper-focus ~ label,
  .p-float-label .p-inputwrapper-filled ~ label {
    top: 1.2rem;
    font-size: 12px;
    font-weight: 400;
      color: #1a1c1f;
    left: 70px;
  }
  .p-input-icon-left.p-float-label > label {
    left: 50px;
  }
  label {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
      color: #1a1c1f;
  }
  .arabicar {
    .arabiclabel {
      right: 15px !important;
    }

    .p-input-icon-left.p-float-label > label {
      right: 15px !important;
    }
    .arabicimg {
      right: 15px;
    }

    .arabictext {
      // padding-right: 2.75rem ;
    }
    .arabictextmob {
      padding-right: 2.75rem;
    }
    .dropdowmar {
      padding-right: 2rem;
    }
    .arabictextmobvalues {
      padding-right: 2.75rem;
      padding-left: 0px;
    }
  }

  .newclass {
    font-family: "tawuniya";
    .p-inputtext {
      font-size: 1rem;
      font-weight: 800;
      color: #1a1c1f;
      font-family: "tawuniya";
      padding: 16px 18px 4px 23px;
      border: none;
      height: 70px;
      box-shadow: none;
    }
  }

  .arabicar {
    font-family: "tawuniya";
    .p-input-icon-left > svg:first-of-type {
      top: 1.4rem;
      left: 15px;
    }
    .p-inputtext {
      font-size: 1rem;
      font-weight: 800;
      color: #1a1c1f;
      font-family: "tawuniya";
      padding: 16px 0px 4px 16px;
      height: 70px;
      box-shadow: none;
    }
  }

  .p-input-icon-left > .p-inputtext {
    border: 1px solid #fff;
    &.p-invalid.p-component {
      border-color: #e24c4c;
    }
  }
  .p-input-icon-left > svg:first-of-type {
    top: 1.4rem;
    left: 15px;
    position: absolute;
    /* top: 50%; */
    margin-top: -0.5rem;
    background: none;
    z-index: 10;
  }
  .p-float-label input:focus ~ label,
  .p-float-label input.p-filled ~ label,
  .p-float-label textarea:focus ~ label,
  .p-float-label textarea.p-filled ~ label,
  .p-float-label .p-inputwrapper-focus ~ label,
  .p-float-label .p-inputwrapper-filled ~ label {
    top: 1.2rem;
    font-size: 12px;
    font-weight: 400;
      color: #1a1c1f;
    left: 70px;
  }
  label {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
      color: #1a1c1f;
  }
`;
export default Calenderwrapper;
